import { render, staticRenderFns } from "./proComFour.vue?vue&type=template&id=40f0ad4c&scoped=true&"
import script from "./proComFour.vue?vue&type=script&lang=js&"
export * from "./proComFour.vue?vue&type=script&lang=js&"
import style0 from "./proComFour.vue?vue&type=style&index=0&id=40f0ad4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0ad4c",
  null
  
)

export default component.exports